import { message } from 'antd'

export default function callAPIError(res) {
  switch (res.status) {
    default:
      message.error('Network error, please try it later！')
  }
  return {
    isFetching: false
  }
}
